import { render } from "./AddingCourse.vue?vue&type=template&id=30780dd0&scoped=true"
import script from "./AddingCourse.vue?vue&type=script&lang=js"
export * from "./AddingCourse.vue?vue&type=script&lang=js"

import "./AddingCourse.vue?vue&type=style&index=0&id=30780dd0&scoped=true&lang=css"
import "./AddingCourse.vue?vue&type=style&index=1&id=30780dd0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30780dd0"]])

export default __exports__